import MediaViewerContainer from './MediaViewer.jsx'

export default MediaViewerContainer
